import constants from "../../constants.js";

export const EnhancedPolicyRulesConditionsCollectionOperationTypeFn = (dataAt) => ({
    displayName: "Collection Operation Type",
    dataAt:
      `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.CollectionOperationType`,
    optionsAt: "CollectionOperationType",
    required: true,
    displayAs: constants.DISPLAY_AS.SELECT,
    defaultValue: "None",
    helpText: "When working with a collection. If you need to count the number of items or sum the items then you use this field."
});
  
export const EnhancedPolicyRulesConditionsIsExpressionFn = (dataAt) => ({
    displayName: "Evaluate as a mathmatical expression?",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.IsExpression`,
    displayAs: constants.DISPLAY_AS.BOOLEAN,
    helpText: "For example, format returns 2+2. The value when returned using an expression will be 4."
});

export const EnhancedPolicyRulesConditionsIsCollectionFn = (dataAt) => ({
    displayName: "Is Collection?",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.IsCollection`,
    displayAs: constants.DISPLAY_AS.BOOLEAN,
    helpText: "Does the source format return more than one value? If so mark as a collection."
});

export const EnhancedPolicyRulesConditionsOperatorTypeFn = (dataAt) => ({
    displayName: "Operator Type",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.OperatorType`,
    optionsAt: "OperatorType",
    required: true,
    displayAs: constants.DISPLAY_AS.SELECT,
    defaultValue: "Equals",
    html: "Contains and NotContains with two values has a special range validation. <br/> " + 
    "Example Contains with values 1 and 10 will validate that Source Format is a value of >=1 and <=10. <br/> " +
    "Range will apply to all Type string and numbers."
});

export const EnhancedPolicyRulesConditionsSourceFormatFn = (dataAt) => ({
    displayName: "Source Format",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.SourceFormat`,
    displayAs: constants.DISPLAY_AS.TEXT_INPUT,
});

export const EnhancedPolicyRulesConditionsConditionTypeFn = (dataAt) => ({
    displayName: "Type",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.Type`,
    optionsAt: "ConditionType",
    required: true,
    displayAs: constants.DISPLAY_AS.SELECT,
    defaultValue: "String"
});

    export const EnhancedPolicyRulesConditionsValuesFn = (dataAt) => ({
    displayName: "Values",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem.Values`,
    displayAs: constants.DISPLAY_AS.TAG_INPUT
});

export const EnhancedPolicyRulesConditionsItemFn = (dataAt, routeParamId = "enhancedPolicyRulesId", endpoint = "EnhancedPolicyRules") => ({
    displayName: "Conditions",
    dataAt: `${dataAt || ""}Conditions.$EnhancedPolicyRulesConditionsItem`,
    displayAs: constants.DISPLAY_AS.RESOURCE,
    children: [
        EnhancedPolicyRulesConditionsSourceFormatFn(dataAt),
        EnhancedPolicyRulesConditionsIsExpressionFn(dataAt),
        EnhancedPolicyRulesConditionsIsCollectionFn(dataAt),

        EnhancedPolicyRulesConditionsCollectionOperationTypeFn(dataAt),
        
        EnhancedPolicyRulesConditionsOperatorTypeFn(dataAt),
        EnhancedPolicyRulesConditionsValuesFn(dataAt),
        {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html:"<b>Format</b can be entered in Values but you must include the full format unlike the Source Format where currly brackets are automatically added.<br/>" + 
    "<div class='htmlmarkup-indent'>Example: {Flight.ArrivalDateTime.Date}<br/>" + 
    "Example Array:  {Flight.ConnectingFlights:{Carrier}|##split##}<br/></div>" + 
    "<b>Named List</b><div class='htmlmarkup-indent'>Named list can be entered as a value. Append ~ to the beginning and end to annotate a named list. <br/>Example: ~CountriesOfConcern~</div>"
        },
        EnhancedPolicyRulesConditionsConditionTypeFn(dataAt),
        
        {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html:"Enhanced Policy uses SmartFormat to build a conditional statement<br/>" + 
        "See the data dictionary on <a href=\"https://trvlcorp.sharepoint.com/sites/ctmna-Technology/SitePages/Lightning-Enhanced-Policy.aspx\" target=\"_blank\">SharePoint: Lightning-Enhanced-Policy</a><br/>" +
        "SmartFormat Wiki: <a href=\"https://github.com/axuno/SmartFormat/wiki\" target=\"_blank\">github.com/axuno/SmartFormat/wiki</a>" +
        ""
        },
        {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html: "<b>Some fields are only available for certain rules.</b><br/>" +
        "<ul>" +
        "<li>SearchCritera, Fare and Flight are fields used in fare validations like Exclude Fare, Show But Not Allow or Exclude From LLF</li>" +
        "<li>Flights, Cars, Hotels, Rails, Grounds are properties used in Form of Payment rules</li>" +
        "<li>CurrentDate, Itinerary, Passenger and User are available for all rules</li>" +
        "</ul>" +
        ""
        },
        {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html: "<h4><b>Collections</b></h4>When accessing a propterty of a collection you need to use a colon.<br/>Example: Cars:{Supplier}<br/> Example: Flights:{Carrier}<br/>" + 
        " Example: Fare.BrandId:<br/>" + 
        "<i><b>Notice the colon at the end of BrandId. This is because Fare is NOT a collection and BrandId is.</b></i>"
        },
        {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html: "<h4><b>Non-Collections</b></h4>When accessing a propterty of a non-collection you need to use a period.<br/> Example: Itinerary.TravelPolicyCode"
        },
        {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html: "" +
        "<table class=\"enhancedPolicyTable\">" +
        "<tr><th>Field</th><th>Format</th></tr>" +
        "<tr><td>Fare Brand Id (Collection)</td><td>Fare.BrandId:</td></tr>" +
        "<tr><td>Fare RBD Code (Collection)</td><td>Fare.ResBookCode:</td></tr>" +
        "<tr><td>Fare Amount</td><td>Fare.Amount</td></tr>" +
        "<tr><td>Fare Cabin</td><td>Fare.CabinCode</td></tr>" +
        "<tr><td>Fare Class</td><td>Fare.FareClassType</td></tr>" +
        "<tr><td>Fare Refundability</td><td>Fare.Refundable</td></tr>" +
        "<tr><td>Flight Equipment Code</td><td>Flight.AircraftType</td></tr>" +
        "<tr><td>Flight Carrier</td><td>Flight.Carrier</td></tr>" +
        "<tr><td>Flight Departure City</td><td>Flight.DestinationLocationCode</td></tr>" +
        "<tr><td>Flight Origin City</td><td>Flight.OriginLocationCode</td></tr>" +
        "<tr><td>Flight Departure Country</td><td>Flight.DestinationCountryCode</td></tr>" +
        "<tr><td>Flight Origin Country</td><td>Flight.OriginCountryCode</td></tr>" +
        "<tr><td>Flight #Stops</td><td>Flight.Stops</td></tr>" +
        "<tr><td>SearchCritera Destination Location Code</td><td>SearchCriteria.Destination.Code</td></tr>" +
        "<tr><td>SearchCritera Destination Country Code</td><td>SearchCriteria.Destination.CountryCode</td></tr>" +
        "<tr><td>SearchCritera Destination Intl</td><td>SearchCriteria.Destination.IsInternational</td></tr>" +
        "<tr><td>SearchCritera Origin Intl</td><td>SearchCriteria.Origin.IsInternational</td></tr>" +
        "<tr><td>User Email</td><td>User.LoggedInUserEmail</td></tr>" +
        "<tr><td>User Role</td><td>User.LoggedInUserRole</td></tr>" +
        "<tr><td>User Name</td><td>User.LoggedInUserName</td></tr>" +
        "<tr><td>CurrentDate</td><td>CurrentDate</td></tr>" +
        "<tr><td>Flights contain carrier (Collection)</td><td>Flights:{Carrier}</td></tr>" +
        "</table>" +
        ""
        },
    ],
    endpoint: endpoint,
    routeParamId: routeParamId,
    removeParamId: "EnhancedPolicyRulesConditionsItem",
    canDelete: true,
});

export const EnhancedPolicyRulesConditionsFn = (dataAt) => {
    return {
        displayName: "Conditions",
        dataAt: `${dataAt || ""}Conditions`,
        displayAs: constants.DISPLAY_AS.GRID,
        canAddNew: true,
        gridItem: EnhancedPolicyRulesConditionsItemFn(dataAt),
        gridCols: [
            { name: "Collection Operation Type", key: "CollectionOperationType" },
            { name: "Is Collection", key: "IsCollection" },
            { name: "Operator Type", key: "OperatorType" },
            { name: "Type", key: "Type" },
            { name: "Source Format", key: "SourceFormat" },
        ],
    }
};


// WEBPACK FOOTER //
// ./src/config/components/forms/conditions.js